import './index.css';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLink } from 'react-router-stack';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import { Header, RouteWrapper, ScreenBackground, Text, View } from '../../../component';
import Button from '@mui/material/Button/Button';

const AddEmailPassword = () => {
  const { AuthTheme } = useTheme();
  const navigate = useLink();
  const [email, setEmail] = useState('');
  const user = useSelector((state: any) => state.user);
  const { emails = [] } = user;

  useEffect(() => {
    const registeredEmail = emails.length > 0 ? emails[0].email : '';
    setEmail(registeredEmail);
  }, [emails]);

  const onPressSubmit = () => {
    navigate.push('/verify_account');
  };

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const containerWrapperColor = {
    backgroundColor: AuthTheme.background
  };

  const mainLabelColor = {
    color: AuthTheme.screenTitle
  };

  const subLabelColor = {
    color: AuthTheme.screenSubTitle
  };
  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header title={'Set/Reset Password'} onClickBack={onClickBack} />
        <View className={'add-email-message-wrapper'} style={containerWrapperColor}>
          <View className={'add-email-message-container'}>
            <View
              className={'add-email-message-content-wrapper'}
              style={{
                backgroundColor: AuthTheme.signUpPhoneLoginBoxBG
              }}>
              <View className={'add-email-message-input-box '}>
                <Text className={'add-email-message-main-label'} style={mainLabelColor}>
                  {I18n.t('SetResetPassword')}
                </Text>
                <Text className={'add-email-message-sub-label'} style={subLabelColor}>
                  {email.length === 0
                    ? I18n.t('PleaseVerifyEmailToAddPassword')
                    : I18n.t('PleaseVerifyEmailToResetPassword')}
                </Text>
              </View>
              <Button
                onClick={onPressSubmit}
                className={'add-email-message-button'}
                style={{
                  backgroundColor: AuthTheme.submitBtnActiveBG
                }}>
                {I18n.t('Continue')}
              </Button>
            </View>
          </View>
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default AddEmailPassword;
